var map = {
	"./ad.svg": "a778",
	"./admin.svg": "ced6",
	"./category.svg": "f428",
	"./collector.svg": "0339",
	"./content.svg": "33c4",
	"./contract.svg": "eeeb",
	"./dashboard.svg": "f782",
	"./device.svg": "2c87",
	"./deviceFunction.svg": "8cee",
	"./equipmentManagement.svg": "6b2a",
	"./example.svg": "30c3",
	"./eye.svg": "4df5",
	"./financial-payment.svg": "95d4",
	"./financial-refund.svg": "3d49",
	"./financial.svg": "fef9",
	"./form.svg": "eb1b",
	"./link.svg": "18f0",
	"./nested.svg": "dcf8",
	"./newsCenter.svg": "dada",
	"./others.svg": "3756",
	"./password.svg": "2a3d",
	"./store.svg": "443b",
	"./system.svg": "30a9",
	"./table.svg": "47f1",
	"./tag.svg": "f1fc",
	"./tanhui.svg": "954b",
	"./tradingCenter.svg": "aa43",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./userAccount.svg": "c78a",
	"./userCredit.svg": "aa77",
	"./users.svg": "5055",
	"./vip.svg": "1296"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";